import { ChangeDetectionStrategy, Component, HostBinding, Inject, Injector, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { DialogService } from '../../../dialog/dialog.service';
import { DialogRef } from '../../../dialog/dialog-ref';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'mtg-dialog-page',
  templateUrl: './dialog-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogPageComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();
  private dialogRef: DialogRef;
  isBrowser = isPlatformBrowser(this.platformId);

  @HostBinding('class.dialog-page')
  defaultClass = true;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private injector: Injector,
  ) {}

  ngOnInit(): void {
    if (!this.isBrowser) {
      return;
    }
    const routeParams = this.getRouteParams(this.route.snapshot);
    const data = this.route.snapshot.data;
    const config = {...data.config};
    delete data.config;
    config.data = {...data, ...routeParams, ...(config.data || {})};
    for (const key of Object.keys(routeParams)) {
      if (config.closeLink) {
        config.closeLink = config.closeLink.replace(`:${key}`, routeParams[key]);
      }
    }
    if (data.component) {
      this.dialogRef = this.dialogService.open(data.component, config, null, this.injector);
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  getRouteParams(route: ActivatedRouteSnapshot): {[key: string]: string} {
    if (!route.parent) {
      return {};
    }
    return {
      ...route.params,
      ...this.getRouteParams(route.parent)
    };
  }
}
